import axios from '~/common/plugins/axios.js'
// 前台业务相关的接口数据暂存，目前只用于分派下拉 20201217
export const state = () => ({
  shopMemberList: [],
  accountLis:[]
});

export const mutations = {
  set_shop_member_list(state, v) {
    state.shopMemberList = v;
  },
  set_account_list(state,v){
    state.accountLis = v;
  }
};

export const actions = {
  // 获取所有成员
  async getShopMemberList({ state, commit }, params) {
    if (state.shopMemberList.length > 0) {
      return state.shopMemberList;
    } else {
      const { code, data } = await axios.$post('/rest/store/contact/v3/contactshopmembers', params);

      if (code !== 200) return [];

      const shopMemberList = data.list;
      commit("set_shop_member_list", shopMemberList);
      return shopMemberList;
    }
  },
  // 获取账户
  async getAccountList({ state, commit }, params) {
    if (state.accountLis.length > 0) {
      return state.accountLis;
    } else {
      const { code, data } = await axios.$post('/rest/store/account/v3/account/search', params);
      if (code !== 200) return [];
      const accountLis = data;
      commit("set_account_list", accountLis);
      return accountLis;
    }
  },
};
export default {
	namespaced: true,
	state,
	actions,
	mutations
}
